import React, {useState} from "react";
import {InputFileAcceptMimes, InputFileAcceptTypes, WarrantyAndReturnMessageTypes} from "../../../../../../core/constants/enums";
import {Col, Row} from "reactstrap";
import UploadButton from "../../../../base/button/upload_button";
import IconButton from "../../../../base/button/icon_button";
import {AttachFile, Telegram} from "@mui/icons-material";
import {Input} from "../../../../base/input/input";
import {sendChatFiles} from "../../../../../../core/services/utils/utils";

const ChatFooter = ({sending, send, createObject, chatsLength}) => {
    const [text, setText] = useState('');

    /**
     * Sends the text as a new message, and clears the input.
     * @param text
     */
    const sendText = (text) => {
        if (!text?.length) return;
        setText('');
        const message = createObject(text, WarrantyAndReturnMessageTypes.text, chatsLength)
        const forSend = [
            message,
        ];
        send(forSend);
    }

    /**
     * For each of the files, sends them to the server api as a new message one by one.
     * @param images {File[]}
     */
    const sendFiles = (images) => {
        send(sendChatFiles(images, createObject) ?? []);
    }

    return (
        <Row className={'no-gutters w-100 justify-content-between px-3 mb-3'}>
            <UploadButton
                labelClassName={'mb-0'}
                disabled={sending}
                accept={[
                    InputFileAcceptMimes.images,
                    InputFileAcceptTypes.heic,
                    InputFileAcceptTypes.heif,
                    InputFileAcceptMimes.videos,
                    InputFileAcceptTypes.pdf,
                    InputFileAcceptTypes.zip,
                    InputFileAcceptTypes.rar,
                ]}
                multiple
                id={'chat-upload-file'}
                onFileSelect={sendFiles}
                className={'flex-grow-0 row align-items-center justify-content-center no-gutters'}>
                <IconButton
                    component={'span'}
                    color={'secondary'}
                >
                    <AttachFile className={'icon normal'}/>
                </IconButton>
            </UploadButton>
            <Col className={'w-100 ml-3 mr-2'}>
                <div className={'w-100 rounded-xxl background-secondary-color-4'}>
                    <Input
                        shadow={false}
                        className={'w-100 chat-input'}
                        value={text}
                        onChange={e => setText(e)}
                        canClear
                        onKeyPress={e => e.key === 'Enter' && sendText(e.target.value)}
                    />
                </div>
            </Col>
            <Col className={'flex-grow-0 row no-gutters align-items-center justify-content-center'}>
                <IconButton
                    disabled={text?.length <= 0}
                    onPressed={() => sendText(text)}
                    color={'secondary'}
                >
                    <Telegram className={'icon normal'}/>
                </IconButton>
            </Col>
        </Row>
    );
}

export default ChatFooter;
